<script>
import { router, findDefaultChannelOfTypeForRally, findDefaultChannelObjOfType, avaUrl } from "../common";
import ContentFlagging from "./ContentFlagging";
import moment from "moment-timezone";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapState("memberships", ["myMembershipByRallyId"]),
    ...mapState("navigation", ["currentRally"]),
    ...mapState("user", ["status", "user", "usersById"]),
    ...mapState("rallies", ["allRalliesByRallyId", "rallyChannelsByRallyId"]),
    ...mapState("shares", ["sharesByContentId", "sharesByShareId"]),
    ...mapState("channels", ["channelsById"]),
    ...mapGetters("blockedUsers", ["isUserBlocked"]),
    // The content's creator is someone the current user has blocked. Used to
    // withhold edit-type actions on that content: you shouldn't be able to
    // change a post from a user you've blocked (and whose body you can't see).
    creatorIsBlockedByMe() {
      const cid = this.content?.attributes?.["creator-id"];
      if (cid == null) { return false; }
      if (parseInt(cid) === parseInt(this.user?.user_id)) { return false; }
      return this.isUserBlocked(cid);
    },
    contentShares(){
        return this.sharesByContentId[parseInt(this.content.id)]
    },
    isAdmin() {
      return this.selectedRally["editable"]
    },
    isRallyWritable() {
      return this.selectedRally["writable"]
    },
    isOwner() {
      return this.myRallyMembership.attributes["role"] == "Owner"
    },
    myRallyMembership(){
      return this.myMembershipByRallyId[this.$route.params.rallyId];
    },
    selectedRally: function() {
      return this.currentRally;
    },
    myRole() {
      return this.selectedRally.membership ? this.selectedRally.membership.attributes["role"] : "Friend";
    },
    userIsOwnerComputed(){
      return this.userIsOwner(this.content)
    },
    canDeleteComputed(){
      return this.canDelete(this.content)
    },
    canEditComputed(c){
      // Blocked creator wins over admin/owner edit rights.
      if (this.creatorIsBlockedByMe) { return false }
      return this.canEdit(this.content)
    },
    canUnshareComputed() {
      return this.canUnshare()
    }
  },
  methods: {


    findContentShareByContextRallyId(contextRallyId) {
      // Convert contextRallyId to numeric (integer) if it's a string
      const numericContextRallyId = parseInt(contextRallyId, 10);

      // Find the object with matching 'context-rally-id'
      const foundContentShare = this.contentShares?.find((contentShare) => {
        const contentShareContextRallyId = contentShare.attributes['context-rally-id'];
        return contentShareContextRallyId == numericContextRallyId;
      });

      return foundContentShare;
    },
    originatingRally(rallyId) {
      // --- This is the rally where the content was originally posted
      const contentShare = this.findContentShareByContextRallyId(rallyId)

      return this.originatingRallyShare(contentShare)
    },

    isDefinitelyNotOriginating(rallyId){
      //want to definitively know...if shares are loaded and this isn't the original 
      const contentShare = this.findContentShareByContextRallyId(rallyId)
      return contentShare && !this.originatingRallyShare(contentShare)
    },
    originatingRallyShare(contentShare) {
      // --- This is the rally where the content was originally posted
      return (contentShare && contentShare.attributes['share-type'] === 'original')
    },
    userIsOwner(c){
      return (c && c.attributes && c.attributes["creator-id"] == this.user.user_id) 
    },
    canDelete(){
       return ((this.content && this.content.attributes.deletable !== undefined) ?  (this.content.attributes.deletable) : (this.userIsOwner || this.isAdmin))
    },
    canEdit(){
      //return this.userIsOwner || this.isAdmin
      console.log("canEdit", this.content.attributes.editable, this.userIsOwner, this.isAdmin, this.isRallyWritable, this.channelsById[this.channelId].attributes.editable, this.channelsById[this.channelId].attributes.writable)
      console.log("canEdit content", this.content)
      return ((this.content && this.content.attributes.editable !== undefined) ?  this.content.attributes.editable : (this.userIsOwner || this.isAdmin))
    },
    canUnshare(){
      let share = this.sharesByShareId[this.shareId]
      if(share && share.attributes){
        // Only allow unshare from the originating (home) rally
        const isOriginating = share.attributes['share-type'] === 'original'
        //return this.isAdmin
        return  (share.attributes['creator-id'] == this.user.user_id || this.isAdmin)
      } else {
        return false
      }
    },
  }
};
</script>
